import { render } from "./PatternComponent.vue?vue&type=template&id=621ba738"
import script from "./PatternComponent.vue?vue&type=script&lang=js"
export * from "./PatternComponent.vue?vue&type=script&lang=js"

import "./PatternComponent.vue?vue&type=style&index=0&id=621ba738&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__